import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';

type DropdownClass = 'b-8';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [CommonModule, DropdownModule, ReactiveFormsModule],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
  @Input() options: any[];
  @Input() clearButton: boolean = false;
  @Input() set control(value: AbstractControl) {
    this.formControl = value as FormControl;
  }
  @Input() value: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() gClass: DropdownClass;

  @Output() selected: EventEmitter<any> = new EventEmitter<any>();

  formControl: FormControl;

  onChange({ value }: any) {
    const selectedValue = this.options.find((i) => i[this.value] === value);
    this.selected.emit(selectedValue);
  }
}
